import { PUBLIC_ID } from "../../../config";
import { useAuthContext } from "../../../contexts/AuthContext";

const useTopicNotificationService = () => { //(shiftId: string, commentId: string | null) => {
    const {userId} = useAuthContext();

    const sendTopicNotification = async (
      title: string | undefined, 
      description: string | undefined, 
      FCMtoken: string | undefined, 
      receiverId: string | undefined,
      dataId: string | null | undefined,
      startAt: string | null | undefined,
      stopAt: string | null | undefined,
      type: string,
      topic?: string,
      isPublic?: boolean) => {
      const uri = 'https://schedulum.org/api/FCM/notification/';
      // var uri = 'http://10.157.57.10:8000/api/FCM/notification/';
      // var uri = 'https://4nkh.ca/FCM/notification/';
      const form_data = new FormData();
      const mobile_auth = "Schedulum-auth-key-ki%@1293ij9j23$as";
      // const validation = "mouahhah";
      form_data.append("mobile_auth", mobile_auth);
      form_data.append("title", title);
      form_data.append("body", description);

      form_data.append("type", type);
      form_data.append("senderId", isPublic? PUBLIC_ID : userId);
      form_data.append("id", dataId);
      form_data.append("startAt", startAt);
      form_data.append("stopAt", stopAt);
      // form_data.append("data", "request");
      form_data.append("topic", topic ? topic : receiverId);//"global");
      // form_data.append("FCMtoken", FCMtoken);
      console.log("form_data: ", Object.fromEntries(form_data));

      return fetch(uri, {
        method: 'POST',
        body: form_data,
        headers: {},
      })
      .then(res => res.json()).then(res => {
        if(res.status == "success"){
          // console.log('success', res.message);
          return res.message;
        } else {
          console.log('error', res.message)
        }
        // setDatas(res.message); // to set this up remove the return before the fetch
        // setLoading(false);
      }).catch((err) => console.log("Error occured", err));
    }

    return {
      sendTopicNotification
    };
};

export default useTopicNotificationService;